import { scrollbarStyle } from '@/shared/styles/scrollbarStyle'
import { styled, Tab, Tabs, Typography } from '@mui/material'

export const StyledContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0;
`

export const StyledLeftDrawer = styled('section')`
  width: 100%;
  height: 100%;
  color: ${props => props.theme.palette.text.primary};
  background-color: ${props => props.theme.palette.background.paper};
  border-radius: 0 8px 8px 0;
`

export const StyledTitle = styled(Typography)`
  padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(12)};
`

export const StyledTabs = styled(Tabs)`
  & .MuiTabs-indicator {
    background-color: ${props => props.theme.palette.secondary.main};
  }
`

export const StyledTab = styled(Tab)`
  color: ${props => props.theme.palette.text.dim};
  font-weight: 400;
  text-transform: none;
  font-size: ${props => props.theme.typography.pxToRem(14)};

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: calc(50% - 3px);
    left: 6px;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background-color: ${props => props.theme.palette.secondary.main};
    opacity: 0;
    transition: opacity 0.2s;
  }

  &.Mui-selected {
    color: ${props => props.theme.palette.text.primary};

    &:before {
      opacity: 1;
    }
  }
`

export const StyledTabPanel = styled('div')`
  width: 100%;
  height: calc(100% - ${(props) => props.theme.typography.pxToRem(109)});
  position: relative;
  overflow-y: auto;
  
  ${scrollbarStyle}
`